import axios from "axios";

/**
 * @typedef TimetableInfoAPI
 *
 * @property {string} prefix_id ID operatora
 * @property {string} timetable_source Informacje o źródle danych rozkładowych
 * @property {string} data_from Zakres danych rozkładowych (od)
 * @property {string} data_to Zakres danych rozkładowych (do)
 * @property {string} feed_version Data i godzina aktualizacji pliku GTFS
 */

/**
 * Pobiera informacje o danych rozkładowych
 * @returns {Promise<TimetableInfoAPI>}
 */
export default function getTimetableInfo() {
    return axios.get('/api/info')
        .then(resp => resp.data);
}
